import { Subject } from 'rxjs';

const subject = new Subject();
const gallerysubject = new Subject();
const virtualsubject = new Subject();
const locationsubject = new Subject();
const cmssubject = new Subject();

const galleryreturnsubject = new Subject();
const locationreturnsubject = new Subject();
const modalSubject = new Subject();


export const SpecService = {
    sendMessage: message => subject.next({ text: message }),
    clearMessages: () => subject.next(),
    getMessage: () => subject.asObservable()
};

export const GalleryService = {
    sendMessage: message => gallerysubject.next({ text: message }),
    clearMessages: () => gallerysubject.next(),
    getMessage: () => gallerysubject.asObservable()
};

export const VirtualService = {
    sendMessage: message => virtualsubject.next({ text: message }),
    clearMessages: () => virtualsubject.next(),
    getMessage: () => virtualsubject.asObservable()
};

export const LocationService = {
    sendMessage: message => locationsubject.next({ text: message }),
    clearMessages: () => locationsubject.next(),
    getMessage: () => locationsubject.asObservable()
};

export const GalleryReturnSubject = {
    sendMessage: message => galleryreturnsubject.next({ text: message }),
    clearMessages: () => galleryreturnsubject.next(),
    getMessage: () => galleryreturnsubject.asObservable()
};

export const LocationReturnSubject = {
    sendMessage: message => locationreturnsubject.next({ text: message }),
    clearMessages: () => locationreturnsubject.next(),
    getMessage: () => locationreturnsubject.asObservable()
};

export const Cmsservice = {
    sendMessage: message => cmssubject.next({ text: message }),
    clearMessages: () => cmssubject.next(),
    getMessage: () => cmssubject.asObservable()
};

export const ModalService = {
    publishModalForward: message => modalSubject.next({ text: message }),
    receiveModalForward: () => modalSubject.asObservable()
};
